import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostRecoverPassword = () => {
  return useMutation({
    mutationFn: authService.postRecoverPassword,
    throwOnError: false,
  });
};
